import { BrowserRouter as Router } from 'react-router-dom';
import { MasterInit } from './_metronic/layout/MasterInit';
import {
	LayoutProvider,
	LayoutSplashScreen
} from '../src/_metronic/layout/core';
import AppRoutes from './app/routes';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Suspense } from 'react';
import ActivityDetection from './app/components/common/ActivityDetection';

const App = () => {
	return (
		<Suspense fallback={<LayoutSplashScreen />}>
			<LayoutProvider>
				<Router>
					<AppRoutes />
				</Router>
				<MasterInit />
				<ToastContainer />
				<ActivityDetection />
			</LayoutProvider>
		</Suspense>
	);
};

export default App;
